import React, { Component, Fragment } from "react";
import './slide.css'
import './fade.css'

export default class Carousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slide: 0,
      class: '',
    };
  }

  next() {
    let animateOut = "slideout";
    let animateIn = "slidein";
    if (this.props.animation === "fade") {
      animateOut = "fadeout";
      animateIn = "fadein";
    }
    this.setState({class: animateOut}, () => {
      setTimeout(()=>this.setState({
        slide: (this.state.slide+1), class: animateIn
      }), 500)
    })
  }

  render() {
    const children = []
    this.props.children.forEach((child) => {
      if (!child) return;
      if (child.constructor === Array) {
        child.forEach((subchild) => children.push(subchild))
      } else {
        children.push(child)
      }
    })

    return (
      <div className={this.state.class}>
        {children[this.state.slide]}
      </div>
    );
  }
} 